import React from "react";
import { Row, Col } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

import getLabel, { getLabelWithTranslationFallback } from "helpers/getLabel";
import usePermissions from "hooks/usePermissions";
import CardNew from "components/molecules/Card/CardNew";
import { IQuotationFromToDetailProps } from "./QuotationType";

function QuotationFromToDetail(props: IQuotationFromToDetailProps) {
  const { data } = props;
  const { organization, service } = data || {};
  const { permissions } = usePermissions();
  const permission = JSON.parse(permissions || "{}");

  return (
    <CardNew loadingSkeletonRowCount={2} title={<FormattedMessage id="quote.listing.fromTo" defaultMessage="From - To" />}>
      <CardNew.Body className="p-0">
        <div className="h-100 d-flex flex-column">
          <Row className="mb-2">
            <Col className="text-secondary">
              <FormattedMessage id="general.companyName" defaultMessage="Company name" />
            </Col>
            <Col>{permission.company_name}</Col>
          </Row>
          <Row className="mb-2">
            <Col className="text-secondary">
              <FormattedMessage id="general.freightMode" defaultMessage="Freight mode" />
            </Col>
            <Col>
              {service?.invited_freight_modes?.length > 0
                ? service.invited_freight_modes.map((freight: string) => (
                    <Row>
                      <Col>{freight}</Col>
                    </Row>
                  ))
                : "-"}
            </Col>
          </Row>
          <Row className="mb-2">
            <Col className="text-secondary">
              {" "}
              <FormattedMessage
                id="new-request.quote-confirmation.organisation.invoiceLocation"
                defaultMessage="Invoice location"
              />
            </Col>
            <Col>{organization?.invoice_location}</Col>
          </Row>
          <Row className="mb-2">
            <Col className="text-secondary">
              <FormattedMessage
                id="general.paymentLocation"
                values={{ paymentLocation: getLabel("Payment location", "capitalize") }}
                defaultMessage="Payment location"
              />
            </Col>
            <Col>{organization?.payment_location}</Col>
          </Row>
          <Row className="mb-2">
            <Col className="text-secondary">
              <FormattedMessage id="quote-request-detail.incoterms" defaultMessage="Incoterms" />
            </Col>
            <Col>{service?.incoterm}</Col>
          </Row>
          <Row className="mb-2">
            <Col className="text-secondary">
              <FormattedMessage id="quote-request-detail.serviceRequirement" defaultMessage="Service requirement" />
            </Col>
            <Col>{service?.service_requirement || "-"}</Col>
          </Row>
          <Row className="mb-3 mt-4">
            <Col className="font-b1">
              <FormattedMessage id="general.additionals" defaultMessage="Additionals" />
            </Col>
          </Row>
          <Row className="mb-2">
            <Col className="text-secondary">
              <FormattedMessage id="general.additionalRequirement" defaultMessage="Additional requirement" />
            </Col>
            <Col>{service?.service_requirement || "-"}</Col>
          </Row>
          <Row className="mb-2">
            <Col className="text-secondary">
              <FormattedMessage id="quote.costRecovery" defaultMessage="Cost recovery" />
            </Col>
            <Col>{organization?.cost_recovery_required ? "Yes" : "No"}</Col>
          </Row>
          <Row className="mb-2">
            <Col className="text-secondary">
              {getLabelWithTranslationFallback("Cost Center / WBS / Project #", {
                style: "capitalize",
                translation: <FormattedMessage id="quote-request-detail.costCenter" defaultMessage="Cost center" />,
              })}
            </Col>
            <Col>{organization?.cost_center || "-"}</Col>
          </Row>
          <Row className="mb-2">
            <Col className="text-secondary">
              <FormattedMessage
                id="new-request.quote-confirmation.organisation.customCostRecoveryField2"
                defaultMessage="Custom cost recovery field 2"
                values={{ customCostRecoveryField2: getLabel("Custom cost recovery field 02", "capitalize") }}
              />
            </Col>
            <Col>{organization?.custom_cost_recovery_field2 || "-"}</Col>
          </Row>
        </div>
      </CardNew.Body>
    </CardNew>
  );
}

export default QuotationFromToDetail;
